// 每天听满 5 分钟算打卡；奖励数额和后端 check_in_reward_service.py 保持一致
export const CHECK_IN_SECONDS = 300
export const DAILY_REWARD = 10
export const STREAK_MILESTONES = [3, 7, 14, 30, 60, 100]
export const MILESTONE_REWARDS = [30, 60, 100, 200, 300, 500]

export function localStudyDate(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
}

export function shiftStudyDate(date, offset) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate() + offset, 12)
}

// 冻结卡：连续每满 7 天得 1 张，最多 2 张；规则和后端 check_in_reward_service.py 一致
export const FREEZE_EVERY = 7
export const FREEZE_LIMIT = 2

// checkIn 是用户记录里的打卡状态：持有的冻结卡和已经被冻结补上的日期
export function studyProgress(raw = {}, now = new Date(), checkIn = {}) {
  const today = localStudyDate(now)
  const daily = {}
  for (const [key, seconds] of Object.entries(raw || {})) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(key) || key > today || typeof seconds !== 'number' || !Number.isFinite(seconds) || seconds <= 0) continue
    const date = new Date(`${key}T12:00:00`)
    if (localStudyDate(date) === key) daily[key] = Math.floor(seconds)
  }
  const completed = new Set(Object.keys(daily).filter(key => daily[key] >= CHECK_IN_SECONDS))
  const checkedToday = completed.has(today)
  const frozen = new Set(checkIn.frozenDays || [])
  const freezes = checkIn.freezes || 0
  const bridges = key => completed.has(key) || frozen.has(key)
  let cursor = checkedToday ? now : shiftStudyDate(now, -1)
  // 今天还没打卡、之前漏了几天：冻结卡够用时，这些天会在今天打卡时补上，连续记录先按保住显示
  let protectedDays = 0
  if (!checkedToday) {
    while (protectedDays <= freezes && !bridges(localStudyDate(shiftStudyDate(cursor, -protectedDays)))) protectedDays++
    if (protectedDays > freezes) protectedDays = 0
    cursor = shiftStudyDate(cursor, -protectedDays)
  }
  let streak = 0
  while (bridges(localStudyDate(cursor))) {
    if (completed.has(localStudyDate(cursor))) streak++
    cursor = shiftStudyDate(cursor, -1)
  }
  // 冻结的日子接起前后两段，但不算天数
  let best = 0
  let run = 0
  let previous = null
  for (const key of [...new Set([...completed, ...frozen])].sort()) {
    const date = new Date(`${key}T12:00:00`)
    run = (previous === localStudyDate(shiftStudyDate(date, -1)) ? run : 0) + (completed.has(key) ? 1 : 0)
    best = Math.max(best, run)
    previous = key
  }
  const monday = shiftStudyDate(now, -((now.getDay() + 6) % 7))
  const week = Array.from({ length: 7 }, (_, index) => {
    const date = shiftStudyDate(monday, index)
    const key = localStudyDate(date)
    return { key, date, seconds: daily[key] || 0, complete: completed.has(key), frozen: frozen.has(key), today: key === today, future: key > today }
  })
  return { daily, today, checkedToday, todaySeconds: daily[today] || 0, streak, best, week, freezes, frozen, protectedDays,
    nextMilestone: STREAK_MILESTONES.find(value => value > streak) || (Math.floor(streak / 100) + 1) * 100 }
}
